/* Will change element's opacity depending on current scroll progress */
import { Directive, OnInit, OnDestroy, HostBinding, ChangeDetectorRef } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Directive({
    selector: '[directive-draw-opacity]',
})
export class DrawOpacitySharedDirective implements OnInit, OnDestroy {
    private _opacityListener$: Subscription;
    private readonly _speedOpacityFactor: number = 1.2;

    @HostBinding('style.opacity') public opacity: number = null;
    @HostBinding('style.transition') public transtion: string = `opacity ${this._drawCollapseService.transition}`;

    constructor(private _drawCollapseService: DrawCollapseService, private _changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit(): void {
        this._opacityListener$ = this._drawCollapseService.drawCurrentHeight$.pipe(distinctUntilChanged())
            .subscribe(offset => {
                const full = 400;
                let current = (Math.pow(full - offset, this._speedOpacityFactor)) * 100 / full;
                if (isNaN(current)) {
                    current = 0;
                }
                this.opacity = Math.floor(100 - current) / 100;
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        if (this._opacityListener$ && !this._opacityListener$.closed) this._opacityListener$.unsubscribe();
    }
}
